<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.nbOffresRecues"
    [label]="step6.getnboffresrecues" [type]="'number'" [rule]="'min_0|max_999'" [name]="getUid() + '_SepAtt_nbOffresRecues'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.informations"
    [label]="step6.getinformations" [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUid() + '_SepAtt_informations'">
</app-form-input>
{{ step6.getspan14 | translate }}
<fieldset>
    <legend>
        {{ step6.getspan15 | translate }}
    </legend>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.nbParticipants"
        [label]="step6.getnbparticipants" [type]="'number'" [rule]="'min_0'" [name]="getUid() + '_SepAtt_nbParticipants'">
    </app-form-input>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.nbParticipantsEtrangers"
        [label]="step6.getnbparticipantsetrangers" [type]="'number'" [rule]="'min_0'"
        [name]="getUid() + '_SepAtt_nbParticipantsEtrangers'">
    </app-form-input>
    {{ step6.getspan16 | translate }}
    
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.primeAttribuee?.valeur"
    [label]="step6.getvaleurprime" [type]="'number'" [rule]="'digits_2'" [name]="getUidPrime() + '_SepAtt_valeur'">
    </app-form-input>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.primeAttribuee?.devise"
    [label]="step6.getdevise" 
    [type]="'autocomplete'" 
    [autoCompleteType]="'DEVISE'"
    [autoCompleteTypeIndex]="0"
    [rule]="'pattern_13'"
    [errorMessage]="{}"
    [name]="getUidPrime() + '_SepAtt_devise'">
    </app-form-input>
</fieldset>